<template>
  <div id="oms-app" class="watermarked">
    <!-- 微应用独立展示：不显示布局组件 -->
    <template v-if="shouldHideLayout">
      <keep-alive>
        <router-view />
      </keep-alive>
      <ForceChangePassword v-model="changePWModal" />
    </template>
    <template v-else>
      <a-layout>
        <a-layout-sider v-model="collapsed" :trigger="null" collapsible>
          <section
            class="oms-menu"
            :class="{ collapsedStyle: collapsed, noCollapsedStyle: !collapsed }"
          >
            <OmsMenu ref="mmsMenuRef" @onClick="onClick" />
          </section>
        </a-layout-sider>
      </a-layout>
      <a-layout id="layout-oms-main">
        <div
          class="oms-main"
          :class="{ collapsedStyle1: collapsed, noCollapsedStyle1: !collapsed }"
        >
          <a-layout-header style="background: rgb(235, 240, 247)">
            <div class="oms-header">
              <OmsHeader @onClick="onClick" />
            </div>
            <div>
              <OmsTabs />
            </div>
          </a-layout-header>
          <a-layout-content>
            <div class="oms-content" id="oms-content">
              <keep-alive>
                <router-view />
              </keep-alive>
            </div>
          </a-layout-content>
        </div>
      </a-layout>
      <ForceChangePassword v-model="changePWModal" />
    </template>
  </div>
</template>

<script>
import OmsMenu from '../layout/OmsMenu.vue';
import OmsHeader from '../layout/OmsHeader.vue';
import OmsTabs from '../layout/OmsTabs.vue';
import Baseunified from '../utils/micro/baseunified';
import ForceChangePassword from '../layout/children/ForceChangePassword.vue';

export default {
  name: 'OmsBase',
  components: {
    OmsMenu,
    OmsHeader,
    OmsTabs,
    ForceChangePassword,
  },
  data() {
    return {
      whiteList: 'MicroBase',
      collapsed: false,
      changePWModal: false,
      whetherAccountExists: localStorage.getItem('whetherAccountExists') || '0'

    };
  },
  mounted() {
    if (localStorage.getItem('pwdStatus') === '0' && this.whetherAccountExists == '1') {
      this.changePWModal = true;
    } else {
      this.changePWModal = false;
    }
    this.Baseunified = new Baseunified();
    this.Baseunified.getWateMarkHost();
    this.Baseunified.starMicroApp();
  },
  methods: {
    onClick(collapsed) {
      this.collapsed = collapsed;
      this.$refs.mmsMenuRef.toggleCollapsed(collapsed);
    },
  },
  computed: {
    routerKey() {
      const reg = /^\/(\w+?)\/.*/g;
      try {
        const { fullPath, name } = this.$route;
        if (name.indexOf('MicroBase') >= 0) {
          const res = reg.exec(fullPath);
          if (res && res.length && res[1]) {
            return res[1];
          }
          return '';
        }
        return '';
      } catch (e) {
        return '';
      }
    },
    shouldHideLayout() {
      const { path, meta } = this.$route;
      // 如果当前路由的 meta 中有 noLayoutPaths 配置
      if (meta && meta.noLayoutPaths && Array.isArray(meta.noLayoutPaths)) {
        // 检查当前路径是否匹配任何一个配置的路径
        return meta.noLayoutPaths.some((noLayoutPath) => {
          // 精确匹配
          if (path === noLayoutPath) {
            return true;
          }
          // 路径前缀匹配（支持路径下的所有子路径）
          if (path.startsWith(noLayoutPath) && (path === noLayoutPath || path[noLayoutPath.length] === '/')) {
            return true;
          }
          return false;
        });
      }

      return false;
    },
  },

};

</script>

<style lang="less" scoped>
@oms-menu-width: 232px;
@oms-menu-min-width: 80px;

.collapsedStyle {
  width: @oms-menu-min-width;
  //transition: width 0.1s ease-out 0s;
}

.noCollapsedStyle {
  width: @oms-menu-width;
  //transition: width 0.1s ease-out 0s;
}

.collapsedStyle1 {
  width: calc(100vw - @oms-menu-min-width);
  //transition: width 0.1s ease-out 0s;
}

.noCollapsedStyle1 {
  width: calc(100vw - @oms-menu-width);
  //transition: width 0.1s ease-out 0s;
}

#oms-app {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-flow: row nowrap;

  .oms-menu {
    height: 100vh;
  }

  .oms-main {
    height: 100vh;
    display: flex;
    flex-flow: column nowrap;

    .oms-header {
      width: 100%;
      height: 60px;
      background: white;
    }

    /deep/.oms-tabs {
      width: 100%;
      height: 32px;
      background: #fff;
      margin-top: 1px;
      background: white;
    }

    .oms-content {
      box-sizing: border-box;
      padding: 8px;
      flex: 1;
      background: #F0F2F5;
      overflow: auto;
      height: calc(100vh - 94px);
    }
  }
}
</style>
